module.exports = __webpack_public_path__ + "static/artist-marketing-the-results-b923e0625dc8076ab7a204a007557d69.webp";